export default "__VITE_ASSET__cdeb29f1__"